<template>
  <div class="text-center">
    <v-menu class="SlcHelpDropDown-menu" offset-y o max-width="250">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          style="display: flex"
          class="SlcHelpDropDown-activator ml-5"
          :class="dark ? 'is-dark' : ''"
          v-bind="attrs"
          v-on="on"
        >
          help_outline
        </v-icon>
      </template>
      <slc-help-menu :links-config="linksConfig" />
    </v-menu>
  </div>
</template>
<script>
import SlcHelpMenu from "./SlcHelpMenu.vue";
import useHelpLinks from "./useHelpLinks";

export default {
  components: { SlcHelpMenu },
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    linksConfig() {
      const { $store } = this;
      return useHelpLinks({ $store });
    }
  }
};
</script>

<style>
@import "factorial-utils-font-weight";
@import "../../utils/utils-headlines.css";

.SlcHelpDropDown-menu {
  color: #232323 !important;
  text-decoration: none !important;
}

.SlcHelpDropDown-activator {
  border-radius: 50%;
  color: var(--color-grey-80) !important;
  height: 32px;
  width: 32px;
}

.SlcHelpDropDown-activator.is-dark {
  color: var(--color-white) !important;
}

.SlcHelpDropDown-activator:focus,
.SlcHelpDropDown-activator:hover {
  background-color: rgba(66, 66, 66, 0.2);
  transform: none !important;
}
</style>
